/**
 * Copyright 2017 Control4 Corporation. All rights reserved.
 * Control4 Confidential and Proprietary Information.
 */

import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';

import { BaseRoutingComponent } from '../common/base-routing/base-routing.component';
import { QuickstartProgrammingService } from './services/quickstart-programming.service';
import { SharedProgrammingService } from '../common/services/shared-programming.service';

@Component({
  selector: 'prg-quickstarts',
  templateUrl: './quickstarts.component.html',
  styleUrls: ['./quickstarts.component.less']
})
export class QuickstartsComponent extends BaseRoutingComponent implements OnInit {

  ready: Observable<boolean>;
  errors: Observable<Array<any>>;
  viewTitle: Observable<string>;

  constructor(
    protected router: Router,
    protected store: Store<any>,
    private shared: SharedProgrammingService,
    private route: ActivatedRoute,
    private quickstarts: QuickstartProgrammingService
  ) {
    super();
    this.ready = this.store.select(s => s.sharedProgramming.ready);
    this.errors = this.store.select(s => s.sharedProgramming.errors);
    this.viewTitle = this.store.select(s => s.sharedProgramming.viewTitle);
  }

  goHome() {
    this.router.navigate(['../programming'], { relativeTo: this.moduleRoot });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstarts.component.ts